export default __webpack_public_path__ + "static/media/Plumed Helm of Divinity.5d733a12.jpg";